import requestor from "requestor";
import BaseRoute from "utils/base_route";
import DataAssetsOverview from "../data_assets_overview";
import DataAssetsCreateView from "../data_assets_create_view";
import DataAssetsBaseContainer from "./containers/data_assets_base";
import workflowsFetchAction from "modules/flowmaster/actions/workflows_fetch";

export default class DataAssetsBase extends BaseRoute {
  constructor(store) {
    super("data-assets", store);
  }

  createChildRoutes() {
    return [
      new DataAssetsOverview(this.store),
      new DataAssetsCreateView(this.store, "create"),
      new DataAssetsCreateView(this.store, "definition/:definitionId"),
      new DataAssetsCreateView(
        this.store,
        "definition/:definitionId/config/:configId",
      ),
    ];
  }

  getIndexRoute(partialNextState, callback) {
    callback(null, {
      onEnter: (nextState, replace) => {
        replace(`${nextState.location.pathname}/overview`);
      },
    });
  }

  getComponents(location, cb) {
    cb(null, DataAssetsBaseContainer);
  }

  onEnter(state) {
    this.fetchData(state);
  }

  fetchData(state) {
    this.fetchDefinitions(state);
  }

  fetchDefinitions(state) {
    const {organisationId} = state.params;
    const {dispatch} = this.store;
    dispatch(
      workflowsFetchAction(requestor)(organisationId, {
        fetch_data_assets: true,
      }),
    );
  }
}
